import { ReactNode } from 'react';

import { NotificationActionTypes, SHOW_NOTIFICATION, HIDE_NOTIFICATION } from './types';

function showNotification(
  message: ReactNode,
  displayType: 'default' | 'error' | 'success',
  cta?: ReactNode,
): NotificationActionTypes {
  return {
    type: SHOW_NOTIFICATION,
    displayType,
    message,
    cta,
  };
}

export const creators = {
  showMessage(message: ReactNode, cta?: ReactNode): NotificationActionTypes {
    return showNotification(message, 'default', cta);
  },

  showSuccessMessage(message: ReactNode, cta?: ReactNode): NotificationActionTypes {
    return showNotification(message, 'success', cta);
  },

  showErrorMessage(message: ReactNode, cta?: ReactNode): NotificationActionTypes {
    return showNotification(message, 'error', cta);
  },

  hideNotification(): NotificationActionTypes {
    return {
      type: HIDE_NOTIFICATION,
    };
  },
};
